import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from "@/components/common/ErrorBoundary";
import { ToastProvider } from "@/components/ui/toast";
import { ColorSchemeSync } from "@/components/ColorSchemeSync";
import { AppRouter } from "@/routes/AppRouter";
import "@/styles/globals.css";
import "@/features/chat/chat-copilot-overrides.css";
import "@copilotkit/react-core/v2/styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <ErrorBoundary>
        <ToastProvider>
          <ColorSchemeSync />
          <AppRouter />
        </ToastProvider>
      </ErrorBoundary>
    </BrowserRouter>
  </StrictMode>,
);
